export default function CameraVideoIcon(props) {
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      xmlns="http://www.w3.org/2000/svg"
      fill={ props.fill || "#6CB6E3"}
      {...props}
    >
      <path
        d="M15.4889 1.06389C15.1686 0.858167 14.77 0.830806 14.4256 0.989222L11.5556 2.30556V1.77778C11.5556 0.795833 10.7597 0 9.77778 0H1.77778C0.795833 0 0 0.795833 0 1.77778V8.88889C0 9.87083 0.795833 10.6667 1.77778 10.6667H9.77778C10.7597 10.6667 11.5556 9.87083 11.5556 8.88889V8.36056L14.425 9.67611C14.5734 9.74425 14.7314 9.77811 14.8886 9.77811C15.0978 9.77811 15.3058 9.71864 15.4883 9.60147C15.8083 9.39722 16 9.04722 16 8.64167V2C16 1.61944 15.8083 1.27222 15.4889 1.06389ZM10.2222 8.88889C10.2222 9.13394 10.0228 9.33333 9.77778 9.33333H1.77778C1.53272 9.33333 1.33333 9.13394 1.33333 8.88889V1.77778C1.33333 1.53272 1.53272 1.33333 1.77778 1.33333H9.77778C10.0228 1.33333 10.2222 1.53272 10.2222 1.77778V8.88889ZM14.6667 8.31944L11.5556 6.89444V3.77222L14.6667 2.34639V8.31944Z"
        fill={props.fill || "#6CB6E3"}
      />
    </svg>
  )
}
